import {DialogActions} from '@mui/material';
import PropTypes from 'prop-types';

import Button from '../../../../../../form/buttons/Button/Button';

const SubmitButton = ({disabled}) => {
  return (
    <DialogActions sx={{margin: '0 auto', width: '90%'}}>
      <Button disabled={disabled} type="submit" variant="contained" size="large" fullWidth sx={{my: 2, fontSize: 14}}>
        Mettre à jour les informations
      </Button>
    </DialogActions>
  );
};

SubmitButton.propTypes = {
  disabled: PropTypes.bool.isRequired
};

export default SubmitButton;
